import { useModel } from "@type-r/react";
import React from "react";
import { AssetType } from "../../api/assetType";
import { Invoice } from "../../api/invoice";
import { InvoiceData } from "../../api/invoiceChange";
import { InvoiceCount } from "../../api/invoiceCount";
import { ConfirmAssetsDataStep } from "../confirm-assets-data-step";
import { InvoiceExternalSystems } from "./externalSystems";
import { InvoiceForm } from "./invoice-form";
import { InvoiceTableColumns } from "./invoice-table-columns";
import { InvoiceQuerry } from "./invoices-querry";

export const ConfirmInvoicesDataStep = ({ isEdit, isAssetsModification, job, next, cancel, startOver, $assetTypeSelect, assetTypeMultiOptions, $refreshEvents }:
    { isEdit: boolean, isAssetsModification: any, job, next?, cancel?, startOver?, $assetTypeSelect?, assetTypeMultiOptions?, $refreshEvents? }) => {
    const invoiceChanges = useModel(InvoiceData);
    const invoiceCountModel = useModel(InvoiceCount);
    const invoiceQuerryModel = useModel(InvoiceQuerry);

    return <>
        <ConfirmAssetsDataStep
            isEdit={isEdit}
            isAssetsModification={isAssetsModification}
            job={job}
            assetName="Invoice"
            assetType={AssetType.invoice}
            assetModel={Invoice}
            countModel={invoiceCountModel}
            queryModel={invoiceQuerryModel}
            tableColumns={InvoiceTableColumns}
            assetChanges={invoiceChanges}
            next={next} cancel={cancel} startOver={startOver}
            externalSystems={InvoiceExternalSystems}
            assetForm={invoice => <InvoiceForm invoice={invoice} />}
            $assetTypeSelect={$assetTypeSelect}
            assetTypeMultiOptions={assetTypeMultiOptions}
            $refreshEvents={$refreshEvents}
        />
    </>
}


